export default __webpack_public_path__ + "static/media/RUB.d1d5c359.svg";